import starry from '../assets/Starry.jpg';
import unknownWorld from '../assets/UnknownWorld.jpg';
import windows11 from '../assets/Windows11.jpg';

export const WALLPAPERS = [starry, unknownWorld, windows11];